/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { mergeQueryKeys, getBaseQueryKey } from "../utils/queryKeyHelpers";

const groupMemberBaseKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.group_members),
  getBaseQueryKey(Query_Keys.employee_groups),
  getBaseQueryKey(Query_Keys.employee_group)
);

export const groupMemberMutationKeyGroups = {
  create: groupMemberBaseKeys,
  update: groupMemberBaseKeys,
  delete: groupMemberBaseKeys,
};
